import slugify from 'slugify';

//add ids to report categories and reports based on the titles
export function setIdByTitles(config){
    return config.map(category => {
        category.id = slugify(category.title).toLowerCase();

        category.reports.map(report => {
            return report.id = slugify(report.title).toLowerCase();
        });

        return category;
    });
}


// WEBPACK FOOTER //
// ./src/utils/config.js